import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../../../../../../Icon';

import styles from './index.styl';

export const HistoryNavigation = ({ componentAvailability }) => {
  return (
    componentAvailability && (
      <div className={styles.wrapper}>
        <Icon name="arrow-left" size={24} className={styles.arrowRight} />
      </div>
    )
  );
};

HistoryNavigation.propTypes = {
  componentCode: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/DataList/Card/LabTestResultCard/HistoryNavigation/index.jsx